const wand = <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    fill="currentColor"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 1200 1200"
>
    <path d="m338.611 0l-59.2 278.697L1.318 344.979l279.788 58.946l66.542 277.08l59.129-278.768l278.142-66.188l-279.766-58.969L338.611 0zM1072.8 12.671L854.259 230.348l119.2 118.733l218.518-217.685L1072.8 12.671zM774.776 309.509L0 1081.265L119.19 1200l774.776-771.756l-119.2-118.735h.01zm240.236 138.212L983.389 596.62l-148.611 35.462l149.481 31.477l35.529 148.032l31.601-148.898L1200 627.23l-149.482-31.479l-35.506-148.03zM771.247 718.285L736.4 882.49l-163.836 38.977l164.8 34.711l39.177 163.244l34.848-164.205l163.835-39.022l-164.776-34.735l-39.201-163.175z" />
</svg>

export default wand